import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import globalStore from '../store';
import { GRID_SIZE } from '../constants/gridConstants';
var BackgroundPatternCanvas = function () {
    var _a = globalStore.useStoreState(function (store) { return store.playerStore; }), canvasHeight = _a.canvasHeight, canvasWidth = _a.canvasWidth, playerBgPattern = _a.playerBgPattern;
    var canvasRef = useRef(null);
    // iPad Safari caps canvas at ~16,777,216 total pixels — scale down if needed
    var MAX_CANVAS_AREA = 16777216;
    var rawArea = canvasWidth * canvasHeight;
    var safeScale = rawArea > MAX_CANVAS_AREA ? Math.sqrt(MAX_CANVAS_AREA / rawArea) : 1;
    var physicalWidth = Math.round(canvasWidth * safeScale);
    var physicalHeight = Math.round(canvasHeight * safeScale);
    useEffect(function () {
        var _a;
        var context = (_a = canvasRef.current) === null || _a === void 0 ? void 0 : _a.getContext('2d');
        if (!context)
            return;
        // Clear the canvas
        context.clearRect(0, 0, physicalWidth, physicalHeight);
        // Scale context so drawing coordinates remain in logical space
        context.setTransform(safeScale, 0, 0, safeScale, 0, 0);
        // Only draw if pattern is square or triangle
        if (playerBgPattern === 'none') {
            context.setTransform(1, 0, 0, 1, 0, 0);
            return;
        }
        context.save();
        context.strokeStyle = '#e0e0e0'; // Light gray color for grid lines
        context.lineWidth = 1;
        if (playerBgPattern === 'square') {
            // Draw square grid
            for (var x = 0; x <= canvasWidth; x += GRID_SIZE) {
                context.beginPath();
                context.moveTo(x, 0);
                context.lineTo(x, canvasHeight);
                context.stroke();
            }
            for (var y = 0; y <= canvasHeight; y += GRID_SIZE) {
                context.beginPath();
                context.moveTo(0, y);
                context.lineTo(canvasWidth, y);
                context.stroke();
            }
        }
        else if (playerBgPattern === 'triangle') {
            // Draw triangle grid
            // For equilateral triangles, the height is: side * sqrt(3) / 2
            var triangleHeight = (GRID_SIZE * Math.sqrt(3)) / 2;
            var triangleSide = GRID_SIZE;
            // Draw triangles in rows
            for (var row = 0; row * triangleHeight <= canvasHeight + triangleHeight; row++) {
                var y = row * triangleHeight;
                var isEvenRow = row % 2 === 0;
                for (var col = -1; col * GRID_SIZE <= canvasWidth + GRID_SIZE; col++) {
                    var baseX = col * GRID_SIZE;
                    var offsetX = isEvenRow ? baseX : baseX + GRID_SIZE / 2;
                    // Draw upward-pointing triangle
                    context.beginPath();
                    context.moveTo(offsetX, y);
                    context.lineTo(offsetX - triangleSide / 2, y + triangleHeight);
                    context.lineTo(offsetX + triangleSide / 2, y + triangleHeight);
                    context.closePath();
                    context.stroke();
                }
                // Draw downward-pointing triangles between upward rows
                if (row > 0) {
                    var prevY = (row - 1) * triangleHeight;
                    var prevIsEvenRow = (row - 1) % 2 === 0;
                    for (var col = -1; col * GRID_SIZE <= canvasWidth + GRID_SIZE; col++) {
                        var baseX = col * GRID_SIZE;
                        var offsetX = prevIsEvenRow ? baseX + GRID_SIZE / 2 : baseX;
                        // Draw downward-pointing triangle
                        context.beginPath();
                        context.moveTo(offsetX, y);
                        context.lineTo(offsetX - triangleSide / 2, prevY);
                        context.lineTo(offsetX + triangleSide / 2, prevY);
                        context.closePath();
                        context.stroke();
                    }
                }
            }
        }
        context.restore();
        context.setTransform(1, 0, 0, 1, 0, 0);
    }, [canvasWidth, canvasHeight, playerBgPattern, physicalWidth, physicalHeight, safeScale]);
    // useEffect(() => {
    //   const resize = () => {
    //     const canvas = canvasRef.current;
    //     if (canvas) {
    //       const context = canvas.getContext('2d');
    //       const dpr = window.devicePixelRatio || 1;
    //       const rect = canvas.getBoundingClientRect();
    //       // Scale the canvas
    //       canvas.width = rect.width * dpr;
    //       canvas.height = rect.height * dpr;
    //       // Scale the drawing operations
    //       context?.scale(dpr, dpr);
    //     }
    //   };
    //   window.addEventListener('resize', resize);
    //   return () => {
    //     window.removeEventListener('resize', resize);
    //   };
    // }, []);
    return (_jsx("canvas", { style: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: canvasWidth,
            height: canvasHeight,
            pointerEvents: 'none',
            zIndex: 0,
        }, width: physicalWidth, height: physicalHeight, draggable: false, className: "backgroundPatternCanvas", ref: canvasRef, "aria-hidden": "true" }));
};
export default BackgroundPatternCanvas;
